export function blockInteraction(state) {
  state.canInteract = false;
}
export function allowInteraction(state) {
  state.canInteract = true;
}

export function bootComplete(state) {
  state.isBooting = false;
}

export function setLanguage(state, payload) {
  state.language = payload;
}

export function updateStep(state, payload) {
  state.step = payload;
}

export function flush(state) {
  state.step = 1;
}
